import React, { useEffect, useState } from 'react'
import { UserContext } from '../OEMChanges/OemAssetsImport'
import { useContext } from 'react'
import { ExpiredStamp, LeftContentTextDiv, MissionActionItemsDiv, MissionDetailsDiv, MissionRewardDiv, MissionTitleDiv, MissionsCardRootDiv, ProgressBar, ProgressBarFilled, ProgressBarText, ProgressbarDiv } from './MissionCard.styles'

import giftRewardIcon from '../assets/missionsCard/sGift.svg'
import playPassRewardIcon from '../assets/missionsCard/Play-Pass.svg'
import instantRewardIcon from '../assets/missionsCard/reward-coin.svg'
import { GV_BONUS_TYPE, PLAY_PASS_BONUS_TYPE, RUPEE_SYMBOL, debugLogStyle } from '../Common/Utils'

function MissionCard(props, ) {

  let assets = useContext(UserContext);
const {isBundleMission, missionData} = props
const [isoemps,setIsOem] = useState(sessionStorage.getItem("channel") === "OEMAPS1");
console.log(`
    isBundleMission >>> `, isBundleMission)
console.log(`
    Bundled Mission >>>>
         `, missionData)

         useEffect(() => { setIsOem(sessionStorage.getItem("channel")==="OEMAPS1")},[sessionStorage.getItem('channel')])
let bundleMission = isBundleMission ? missionData: ''

    const missionType = missionData?.missionType?.toLowerCase()
    const missionStatus = missionData?.status?.toLowerCase() 
    const bonusType = missionData?.bonusType.toLowerCase() 
    const userRewardStatus = missionData?.rewardStatus?.toLowerCase() 

    let shouldFadeOut = missionData.optIn === 'N' ? true : false

    let progressFillPercentage = isBundleMission ? (Number(missionData.totalReward) - Number(missionData.pendingReward)) * (100 / missionData.totalReward) :  missionData.valueConsumed * (100 / missionData.maxValue);
  
    console.log(`%c progressFillPercentage >>> `,debugLogStyle, progressFillPercentage)
    
    progressFillPercentage = progressFillPercentage !== NaN ? progressFillPercentage + '%' : '0%'

  function convertToWords(number, challenge) {
    console.log("Num in convert => ", number);
    let toConvert = Number(number)
    if (number === undefined || number === '' || number === null || number < 0) return ''
    try {
      const numberString = number?.toString();
      if (number >= 10000000) {
        const croreIndex = numberString?.length - 7;
        let amtText = numberString?.slice(0, croreIndex);
        return `${amtText} ${numberString.slice(amtText.length, amtText.length + 1) !== '00' ? '.' + numberString.slice(amtText.length, amtText.length + 1) : ''} Cr`;

        //   const num = toConvert / 10000000
        //   return `${Math.round(num)} Cr`
      } else if (number >= 100000) {
        const croreIndex = numberString?.length - 5;
        let amtText = numberString?.slice(0, croreIndex);
        // return amtText + '.' + numberString.slice(amtText.length, amtText.length + 2) + ' Lac';
        return `${amtText}${numberString?.slice(amtText.length, amtText.length + 1) !== '00' ? '.' + numberString?.slice(amtText.length, amtText.length + 1) : ''} Lac`;

        //   const num = toConvert / 100000
        //   return `${Math.round(num)} Lac`
      } else {
        let formattedNumber = number;
        if (Number(number)) formattedNumber = Number(number)?.toLocaleString()
        // Check for "realstake" challenge and add .0 for integers
        if (challenge === 'realstake' && Number?.isInteger(number)) {
          return `${formattedNumber}.0`;
        }
        console.log("check => ", formattedNumber)
        return formattedNumber;
      }
    } catch (error) {
      console.log("error while converting number to words", error);
    }
  }

  return (
  <MissionsCardRootDiv isoemps={isoemps} id='Root-Mission-Card'>
    {/* This Portion is for Rewards */}
    <MissionRewardDiv isoemps={isoemps} style={{ width: isBundleMission ? '35%' : '27%'}} id='Mission-Reward-Section'>
              <div>
                  {isBundleMission ?
                      <span style={{ fontWeight: '400', fontSize: '0.75rem', color: '#F2F2F2' }}>Rewards Worth </span>
                      :
                      <img
                          src={
                              bonusType === GV_BONUS_TYPE
                                  ? giftRewardIcon
                                  : bonusType === PLAY_PASS_BONUS_TYPE
                                      ? playPassRewardIcon
                                      : assets?.assets?.instantrupee
                          }
                          style={{}}
                          alt="gift-scon"
                      />}
              </div>

          <div style={{ fontSize: '1.375rem', fontWeight: '900', 
        //   color: '#FFD781' ,
            color:'#E6AC2F',
            textShadow: '0px 2px #00000066'
            // box-shadow: 0px 2px 0.5px 0px #00000066;

          }}>
            {RUPEE_SYMBOL}
            {convertToWords(missionData.totalReward,"xxxx")}
          </div>

          {isBundleMission ? '' : <LeftContentTextDiv  isoemps={isoemps}>
            {bonusType === GV_BONUS_TYPE
              ? 'Voucher'
              : bonusType === PLAY_PASS_BONUS_TYPE
              ? 'Play Pass'
              : 'Instant Cash'}
          </LeftContentTextDiv>}
        
    </MissionRewardDiv>

    

    {/* This Portion is for Description / Information */}

    <MissionDetailsDiv id='Missions-Info-Div' style={{ width: isBundleMission ? '65%' : '73%'}}>

    <MissionTitleDiv isoemps={isoemps} style={{
        height: missionData.missionDescription !== 'NA' && !isBundleMission ? '35%' : ''
    }} >
            <div style={{   height:missionData.missionDescription !== 'NA' && !isBundleMission ? '100%' : '',
                            display:'flex', flexDirection:'column', justifyContent: 'space-between' }}>
              <div>{missionData.missionName}</div>
              {missionData.missionDescription !== 'NA' && !isBundleMission ? (
                <div style={{ fontSize: '0.75rem', fontWeight: '400' }}>{missionData.missionDescription}</div>
              ) : (
                ''
              )}
               {/* <div style={{ fontSize: '0.75rem', fontWeight: '400' }}>{'missionData.missionDescription'}</div> */}
            </div>

            
          </MissionTitleDiv>

              <MissionActionItemsDiv isoemps={isoemps}>

                  <div
                      id="Progressbar"
                      style={{ width: '65%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem' }}
                  >
                      <ProgressbarDiv>
                          <ProgressBar isoemps={isoemps} shouldShade={shouldFadeOut} isFromBundle={false}>
                              <ProgressBarFilled isoemps={isoemps} shouldShade={shouldFadeOut} fillArea={progressFillPercentage} />
                          </ProgressBar>
                      </ProgressbarDiv>
                      <ProgressBarText isoemps={isoemps} id="progress-text-div" style={{ width: '100%' }}>
                          {/* {progressFillPercentage != '0%' ? missionData.progressBarText : ''} */}
                          {missionData.progressBarText}
                      </ProgressBarText>
                  </div>

              </MissionActionItemsDiv>




    </MissionDetailsDiv>

    <ExpiredStamp isoemps={isoemps} style={{position:'absolute', left:'28%', top:'35%'}}>
      <span style={{ fontSize:'0.75rem', fontWeight:'700', rotate:'15 deg'}}> EXPIRES ON WITHDRAW </span>
    </ExpiredStamp>



  </MissionsCardRootDiv>)
}

export default MissionCard